import { render, staticRenderFns } from "./CostCentersPage.vue?vue&type=template&id=0975e9b2&"
import script from "./CostCentersPage.vue?vue&type=script&lang=js&"
export * from "./CostCentersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports